import dynamic from 'next/dynamic';

const HandOverVehicleDetails = dynamic(() =>
  import('./HandOverVehicleDetails/HandOverVehicleDetails')
);
const DriversLastStep = dynamic(() =>
  import('./DriversLastStep/DriversLastStep')
);
const DriverFilters = dynamic(() => import('./DriverFilters/DriverFilters'));
const DriversTerms = dynamic(() => import('./DriversTerms/DriversTerms'));

const DriversStepFront = dynamic(() =>
  import('./DriversStepFront/DriversStepFront')
);
const DriversStepLeft = dynamic(() =>
  import('./DriversStepLeft/DriversStepLeft')
);
const DriversStepTop = dynamic(() => import('./DriversStepTop/DriversStepTop'));
const DriversStepBack = dynamic(() =>
  import('./DriversStepBack/DriversStepBack')
);
const DriversStepRight = dynamic(() =>
  import('./DriversStepRight/DriversStepRight')
);
const DriversStepInterior = dynamic(() =>
  import('./DriversStepInterior/DriversStepInterior')
);
const DriversStepKmFuel = dynamic(() =>
  import('./DriversStepKmFuel/DriversStepKmFuel')
);
const DriversStepExtraComment = dynamic(() =>
  import('./DriversStepExtraComment/DriversStepExtraComment')
);

export {
  HandOverVehicleDetails,
  DriversLastStep,
  DriverFilters,
  DriversTerms,
  DriversStepFront,
  DriversStepLeft,
  DriversStepTop,
  DriversStepBack,
  DriversStepRight,
  DriversStepInterior,
  DriversStepKmFuel,
  DriversStepExtraComment,
};
